import React, { useState, useEffect, useRef } from 'react';
import Editor from '@monaco-editor/react';
import Select from 'react-select'
import StyledSelect from '../components/StyledSelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser, faCopy } from '@fortawesome/free-solid-svg-icons';
import { format } from 'sql-formatter';
import { toast } from 'react-toastify';

const outputOptions = [
  { value: 'sql', label: 'SQL' },
  { value: 'mysql', label: 'MySQL'},
  { value: 'postgres', label: 'PostgreSQL'},
  { value: 'oracle', label: 'Oracle' },
  { value: 'mssql', label: 'MS SQL' },
  { value: 'bigquery', label: 'Big Query'},
  { value: 'mariadb', label: 'MariaDB'},
  { value: 'plsql', label: 'plsql'},
  { value: 'redshift', label: 'Redshift'},
  { value: 'singlestoredb', label: 'SingleStore' },
  { value: 'snowflake', label: 'Snowflake' },
  { value: 'spark', label: 'Spark' },
  { value: 'sqlite', label: 'Sqlite' },
  { value: 'trino', label: 'trino' }
]

const SQLFormatPage = (props) => {
  const [originalInput, setOriginalInput] = useState('');
  const [convertedOutput, setConvertedOutput] = useState('');
  const [outputDataType, setOutputDataType] = useState('sql');
  const [dataTypeOutputOptions, setDataTypeOutputOptions] = useState(outputOptions[0])
  const { editorTheme, appTheme } = props;

  const handleoutputSelectChange = (option) => {
    setDataTypeOutputOptions(option)
    setOutputDataType(option.value)
  }

  const showErrorMessage = (errorMessage) => {
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalInput(content);
    };
    reader.readAsText(file);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(convertedOutput);
  };

  useEffect(() => {
    if (originalInput && outputDataType) {
      try {
        const newOutput = format(originalInput, { language: outputDataType })
        setConvertedOutput(newOutput)
      } catch (error) {
        showErrorMessage("Unsupported")
        setConvertedOutput("")
      }
    }
  }, [originalInput, outputDataType]);
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>SQL Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <Editor
              height="50vh"
              value={originalInput}
              onChange={(value, event) => setOriginalInput(value)}
              language='sql'
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <input
              type="file"
              accept="*"
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              type="button"
              onClick={() => document.querySelector('input[name="file1"]').click()}
              className="text-white mr-2 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalInput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full xl:col-auto">
        <div className="h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>SQL Output</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <StyledSelect appTheme={appTheme} value={dataTypeOutputOptions} options={outputOptions} onChange={handleoutputSelectChange} />
            <br/>
            <Editor 
              height="43.5vh"
              value={convertedOutput}
              language='sql'
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <button
              type="button"
              onClick={copyToClipboard}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCopy}/>
              &nbsp; Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SQLFormatPage;
